
import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SideMenu from './SideMenu';
import * as XLSX from 'xlsx'; // Import the XLSX library
import { FaDownload } from 'react-icons/fa'; // Import FontAwesome download icon

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SalesPage = () => {
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [note, setNote] = useState('');

  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  // const isAdmin = localStorage.getItem('role') ==='Admin';
  // const isTeam = localStorage.getItem('role') === 'Team';
  // const isAdminOrTeam = isAdmin || isTeam ;
  // console.log('isAdmin:' , isAdmin);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/fetchservices`);
        const data = await response.json();
        setRequests(data);
        setFilteredRequests(data); // Initialize filteredRequests with all requests
      } catch (error) {
        console.error('Error fetching requests:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);


  const toggleExpandDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const truncateText = (text, limit) => {
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  };

  const handleFilterChange = (e, column) => {
    const value = e.target.value;
    let filteredData = [...requests];

    if (value !== 'All') {
      filteredData = filteredData.filter((request) =>
        column === 'services'
          ? request.services.includes(value)
          : request[column] === value
      );
    }

    setFilteredRequests(filteredData);
  };

//   const handleStatusFilterChange = (e) => {
//     const value = e.target.value;
//     if (value === 'All') {
//       setFilteredRequests(requests);
//     } else {
//       const filteredData = requests.filter((request) => request.status === value);
//       setFilteredRequests(filteredData);
//     }
//   };

//   const handleDelete = async (index) => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/delete-request/${index}`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//         setRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
//         setFilteredRequests((prevRequests) => prevRequests.filter((_, i) => i !== index));
//       } else {
//         alert('Error deleting request');
//       }
//     } catch (error) {
//       console.error('Error deleting request:', error);
//     }
//   };

//   const handleStatusChange = async (email, newStatus) => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/update-status/`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email ,status: newStatus }),
//       });

//       if (response.ok) {
//         setRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request.email === email ? { ...request, status: newStatus } : request
//           )
//         );
//         setFilteredRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request.email === email ? { ...request, status: newStatus } : request
//           )
//         );
//         alert('Status updated successfully');
//       } else {
//         console.error('Failed to update status');
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };

  // Open note editor
  const openNoteEditor = (email) => {
    setEditingNoteId(email);
    const savedNotes = JSON.parse(localStorage.getItem('notes')) || {};
    setNote(savedNotes[email] || '');
  };

  // Save note to localStorage
  const saveNote = () => {
    const notes = JSON.parse(localStorage.getItem('notes')) || {};
    notes[editingNoteId] = note;
    localStorage.setItem('notes', JSON.stringify(notes));
    setEditingNoteId(null);
    alert('Note saved successfully!');
  };


  // Export table data to Excel
  const exportToExcel = () => {
    const exportData = filteredRequests.map((request , index) => ({
      'ID':request.id || index + 1,
      'Services': request.services,
      'Description': request.description,
      
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sales Data');

    // Save the file
    XLSX.writeFile(workbook, 'sales_data.xlsx');
  };



  return (
    <div className="sales-ctn">
      <div className="page-container">
        <Navbar />
        <div className="content-wrapper">
          <SideMenu />
          <div className="table-wrapper" >
            <h1 style={{position:'absolute'}}>Welcome Partners!</h1>

             {/* Download Button */}
             <div className='download-btn'>
             <FaDownload
                onClick={exportToExcel}
                style={{
                  cursor: 'pointer',
                  fontSize: '20px',
                  color: 'black',
                }}
                title="Download Excel"
              />           
            </div>

            
            <br />
            <table>
              <thead>
                <tr>
                  <th>ID</th>
              
                  <th>
                    Services
                    <select
                      onChange={(e) => handleFilterChange(e, 'services')}
                      style={{ marginLeft: '10px' }}
                    >
                      <option value="All">All</option>
                      <option value="AI Services">AI Services</option>
                      <option value="Web Development">Web Development</option>
                      <option value="App Development">App Development</option>
                      <option value="Cloud Services">Cloud Services</option>
                    </select>
                  </th>
                  <th className='description'>Description</th>
                 
                  <th className='notes'>Notes</th>
                

                  {/* <th>
                    Status
                    <select
                      onChange={handleStatusFilterChange}
                      style={{ marginLeft: '10px' }}
                    >
                      <option value="All">All</option>
                      <option value="In Process">In Process</option>
                      <option value="Closed">Closed</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Development on going">Development on going</option>
                      <option value="Future Prospect">Future Prospect</option>
                    </select>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="11">Loading...</td>
                  </tr>
                ) : (
                  filteredRequests.map((request, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                     
                      <td>{request.services}</td>
                      
                      <td>
                      <div className='description'>
                        {expandedDescriptions[request.id]
                          ? request.description
                          : truncateText(request.description, 150)}
                        {request.description.length > 200 && (
                          <button
                            onClick={() => toggleExpandDescription(request.id)}
                            style={{
                              marginLeft: '10px',
                              background: 'none',
                              color: 'blue',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            {expandedDescriptions[request.id]
                              ? 'Read Less'
                              : 'Read More'}
                          </button>
                        )}
                        </div>
                      </td>

                    
                      <td className='notes'>  
                        <div className='edt' onClick={() => openNoteEditor(request.email)}>
                        <img src='/class-notes.png' alt='Notes' />
                        <p>{
                          JSON.parse(localStorage.getItem('notes'))?.[request.email] ||
                          'No Notes Available'
                        }</p>
                        </div>
                       
                      </td>
                     
                      {/* // )} */}
                      {/* <td>
                        <select
                          value={request.status || ''}
                          onChange={(e) =>
                            handleStatusChange(request.email, e.target.value)
                          }
                        >
                          <option value="In Process">In Process</option>
                          <option value="Closed">Closed</option>
                          <option value="Delivered">Delivered</option>
                          <option value="Development on going">
                            Development on going
                          </option>
                          <option value="Future Prospect">Future Prospect</option>
                        </select>
                     </td> */}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        {editingNoteId && (
          <div className="modal">
            <div className="modal-content">
              <h2>Edit Note</h2>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Add or edit your note here"
                rows={5}
              />
              <div className='modalbtn'>
              <button onClick={saveNote}>Save</button>
              <button onClick={() => setEditingNoteId(null)}>Cancel</button>
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default SalesPage;
